var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftRai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7628 38.7585H15V15H38.7628V38.7585Z",
    fill: "#F1511B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 38.7585H41.2374V15H64.9998V38.7585Z",
    fill: "#80CC28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7621 65H15V41.2418H38.7621V65Z",
    fill: "#0191FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 65H41.2376V41.2418H65V65Z",
    fill: "#FBBC09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftRai);
export default __webpack_public_path__ + "static/media/microsoft-rai.95c7267c06c624b0f49d8936adf12ca3.svg";
export { ForwardRef as ReactComponent };